/* Evan Red: opener-video. Kiest desktop/mobiel bron, speelt alleen in beeld, lost bij scrollen op in de sectie eronder
   ([data-er-lead], anders de film); die wacht zolang (data-lead). Alle maten komen uit het sticky vlak zelf (100svh),
   zodat fade en scrolldoelen kloppen als de Safari-balk verandert of het scherm draait.
   "Explore the collection" springt direct naar de modelkeuze; de scrollhint naar het einde van de overgang.
   Werkdraft 1 nov 2026: zonder overgangsruimte (span 0, bv. als H3 uit staat) nooit 'opgelost': de video blijft gewoon staan en spelen
   tot hij uit beeld scrolt (anders telde de transparante header als 'voorbij' en stond de video stil op een zwart eerste beeld). */
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* header die bij omlaag scrollen verdwijnt (hide-on-scroll) of niet meeschuift: geen ruimte reserveren */
  function headerOffset() {
    var x = document.querySelector('x-header');
    if (x && x.hasAttribute('hide-on-scroll')) return 0;
    if (getComputedStyle(document.documentElement).getPropertyValue('--header-is-sticky').trim() !== '1') return 0;
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    return isNaN(v) ? 0 : v;
  }
  function go(top) { window.scrollTo({ top: Math.max(0, top), behavior: REDUCE ? 'auto' : 'smooth' }); }

  function init(root) {
    if (root.__erop) return; root.__erop = true;
    var video = root.querySelector('.erop__video');
    var sticky = root.querySelector('.erop__sticky');
    var cue = root.querySelector('.erop__cue');
    var mq = window.matchMedia('(max-width: 699px), (max-aspect-ratio: 3/4)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var save = navigator.connection && navigator.connection.saveData;
    var current = '';
    var inView = true, gone = false, ticking = false, dead = false;
    var off = [], io = null;
    function on(el, ev, fn, o) { el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); }
    function vh() { return sticky.offsetHeight || window.innerHeight; }
    function span() { return Math.max(0, root.offsetHeight - vh()); }

    function pick() {
      var src = mq.matches ? root.getAttribute('data-src-m') : root.getAttribute('data-src-d');
      if (!src || src === current) return;
      current = src;
      root.classList.remove('is-playing');
      video.src = src;
      video.load();
      if (inView && !gone) play();
    }
    /* geweigerde autoplay: de poster blijft gewoon staan */
    function play() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    function onPlaying() { root.classList.add('is-playing'); }
    function onVis() { if (document.hidden) video.pause(); else if (inView && !gone && current) play(); }

    if (video) on(video, 'playing', onPlaying);
    if (!reduce && !save && video) {
      video.muted = true;
      pick();
      if (mq.addEventListener) { mq.addEventListener('change', pick); off.push(function () { mq.removeEventListener('change', pick); }); }
      else if (mq.addListener) { mq.addListener(pick); off.push(function () { mq.removeListener(pick); }); }
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) {
          inView = es[0].isIntersecting;
          if (inView && !gone) play(); else video.pause();
        }, { threshold: 0.02 });
        io.observe(root);
      }
      on(document, 'visibilitychange', onVis);
    }

    /* sectie eronder laten wachten tot de video is opgelost */
    var film = null;
    function lead() {
      var s = span();
      film = film || document.querySelector('[data-er-lead]') || document.querySelector('.er2');
      if (film) { film.setAttribute('data-lead', s); film.style.setProperty('--er2-lead', s + 'px'); }
    }
    lead();

    function update() {
      ticking = false;
      if (dead) return;
      var r = root.getBoundingClientRect();
      var s = span();
      var p = s > 0 ? Math.min(1, Math.max(0, -r.top / s)) : 0;
      var e = p * p * (3 - 2 * p);
      sticky.style.opacity = (1 - e).toFixed(3);
      root.classList.toggle('is-scrolled', -r.top > 12);
      var g = p >= 0.999;
      if (g !== gone) {
        gone = g;
        root.classList.toggle('is-gone', g);
        if (g) video.pause(); else if (inView && current) play();
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    function onResize() { lead(); onScroll(); }
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onResize);
    on(window, 'orientationchange', onResize);
    update();

    if (cue) on(cue, 'click', function () {
      go(root.getBoundingClientRect().top + window.pageYOffset + span());
    });

    root.__eropDestroy = function () {
      dead = true;
      if (io) io.disconnect();
      off.forEach(function (f) { f(); });
      if (video) video.pause();
      root.__erop = false;
    };
  }
  function boot() { document.querySelectorAll('.erop').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (!window.__eropBoot) {
    window.__eropBoot = true;
    /* ankerlinks in de opener en de ER-secties ("Explore the collection", "Choose your model"): zacht scrollen naar het doel */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || !a.closest('.erop, .erd, .erh')) return;
      var id = a.getAttribute('href').slice(1);
      var t = id ? document.getElementById(id) : null;
      if (!t) return;                                   /* geen doel op de pagina: gewone link */
      e.preventDefault();
      go(t.getBoundingClientRect().top + window.pageYOffset - headerOffset());
    }, true);
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.querySelectorAll) return;
      e.target.querySelectorAll('.erop').forEach(function (r) { if (r.__eropDestroy) r.__eropDestroy(); });
    });
  }
})();
